import { type VisaBulletinTrendMonthlySeriesItem } from '@/pages/ui/types'

import { type ResGetCaseVisaBulletinTrendQuery } from '@/lib/queries/case/public/trend/visa-bulletin/types'

export const mockVisaBulletinMonthlySeries: VisaBulletinTrendMonthlySeriesItem[] = [
  {
    date: '2022-04-01',
    filingDateDecimalYear: 2015.3051369863,
    finalActionDateDecimalYear: 2012.1649590164,
    filingDate: 1429693199999,
    finalActionDate: 1330592400000,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
  {
    date: '2022-05-01',
    filingDateDecimalYear: 2015.3106925419,
    finalActionDateDecimalYear: 2012.1705145719,
    filingDate: 1429868400001,
    finalActionDate: 1330768079998,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
  {
    date: '2022-06-01',
    filingDateDecimalYear: 2015.3162480974,
    finalActionDateDecimalYear: 2012.1760701275,
    filingDate: 1430043599999,
    finalActionDate: 1330943759999,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
  {
    date: '2022-07-01',
    filingDateDecimalYear: 2015.321803653,
    finalActionDateDecimalYear: 2012.1816256831,
    filingDate: 1430218800001,
    finalActionDate: 1331119440001,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
  {
    date: '2022-08-01',
    filingDateDecimalYear: 2015.3273592085,
    finalActionDateDecimalYear: 2012.1871812386,
    filingDate: 1430393999999,
    finalActionDate: 1331295119999,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
  {
    date: '2022-09-01',
    filingDateDecimalYear: 2015.3329147641,
    finalActionDateDecimalYear: 2012.1927367942,
    filingDate: 1430569200000,
    finalActionDate: 1331470800000,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
  {
    date: '2022-10-01',
    filingDateDecimalYear: 2015.3384703196,
    finalActionDateDecimalYear: 2012.1982923497,
    filingDate: 1430744399998,
    finalActionDate: 1331646479999,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
  {
    date: '2022-11-01',
    filingDateDecimalYear: 2015.3440258752,
    finalActionDateDecimalYear: 2012.2038479053,
    filingDate: 1430919600000,
    finalActionDate: 1331822160000,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
  {
    date: '2022-12-01',
    filingDateDecimalYear: 2015.3495814307,
    finalActionDateDecimalYear: 2012.2094034608,
    filingDate: 1431094799998,
    finalActionDate: 1331997839998,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
  {
    date: '2023-01-01',
    filingDateDecimalYear: 2015.5051369863,
    finalActionDateDecimalYear: 2012.3649590164,
    filingDate: 1436000399999,
    finalActionDate: 1336916880000,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
  {
    date: '2023-02-01',
    filingDateDecimalYear: 2015.4940258752,
    finalActionDateDecimalYear: 2012.3538479053,
    filingDate: 1435650000000,
    finalActionDate: 1336565520000,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
  {
    date: '2023-03-01',
    filingDateDecimalYear: 2015.4829147641,
    finalActionDateDecimalYear: 2012.3427367942,
    filingDate: 1435299600000,
    finalActionDate: 1336214160000,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
  {
    date: '2023-04-01',
    filingDateDecimalYear: 2015.471803653,
    finalActionDateDecimalYear: 2012.3316256831,
    filingDate: 1434949200001,
    finalActionDate: 1335862800001,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
  {
    date: '2023-05-01',
    filingDateDecimalYear: 2015.4606925419,
    finalActionDateDecimalYear: 2012.3205145719,
    filingDate: 1434598800001,
    finalActionDate: 1335511439998,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
  {
    date: '2023-06-01',
    filingDateDecimalYear: 2015.4495814307,
    finalActionDateDecimalYear: 2012.3094034608,
    filingDate: 1434248399998,
    finalActionDate: 1335160079998,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
  {
    date: '2023-07-01',
    filingDateDecimalYear: 2015.4384703196,
    finalActionDateDecimalYear: 2012.2982923497,
    filingDate: 1433897999998,
    finalActionDate: 1334808719999,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
  {
    date: '2023-08-01',
    filingDateDecimalYear: 2015.4273592085,
    finalActionDateDecimalYear: 2012.2871812386,
    filingDate: 1433547599999,
    finalActionDate: 1334457359999,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
  {
    date: '2023-09-01',
    filingDateDecimalYear: 2015.4162480974,
    finalActionDateDecimalYear: 2012.2760701275,
    filingDate: 1433197199999,
    finalActionDate: 1334105999999,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
  {
    date: '2023-10-01',
    filingDateDecimalYear: 2015.4051369863,
    finalActionDateDecimalYear: 2012.2649590164,
    filingDate: 1432846799999,
    finalActionDate: 1333754640000,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
  {
    date: '2023-11-01',
    filingDateDecimalYear: 2015.4301369863,
    finalActionDateDecimalYear: 2012.2899590164,
    filingDate: 1433635199999,
    finalActionDate: 1334545200000,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
  {
    date: '2023-12-01',
    filingDateDecimalYear: 2015.4551369863,
    finalActionDateDecimalYear: 2012.3149590164,
    filingDate: 1434423599999,
    finalActionDate: 1335335760000,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
  {
    date: '2024-01-01',
    filingDateDecimalYear: 2015.4801369863,
    finalActionDateDecimalYear: 2012.3399590164,
    filingDate: 1435211999999,
    finalActionDate: 1336126320000,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
  {
    date: '2024-02-01',
    filingDateDecimalYear: 2015.5051369863,
    finalActionDateDecimalYear: 2012.3649590164,
    filingDate: 1436000399999,
    finalActionDate: 1336916880000,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
  {
    date: '2024-03-01',
    filingDateDecimalYear: 2015.5301369863,
    finalActionDateDecimalYear: 2012.3899590164,
    filingDate: 1436788799999,
    finalActionDate: 1337707440000,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
  {
    date: '2024-04-01',
    filingDateDecimalYear: 2015.6051369863,
    finalActionDateDecimalYear: 2012.4649590164,
    filingDate: 1439153999999,
    finalActionDate: 1340079120000,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
  {
    date: '2024-05-01',
    filingDateDecimalYear: 2015.609303653,
    finalActionDateDecimalYear: 2012.4691256831,
    filingDate: 1439285400001,
    finalActionDate: 1340210880001,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
  {
    date: '2024-06-01',
    filingDateDecimalYear: 2015.6134703196,
    finalActionDateDecimalYear: 2012.4732923497,
    filingDate: 1439416799998,
    finalActionDate: 1340342639999,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
  {
    date: '2024-07-01',
    filingDateDecimalYear: 2015.6176369863,
    finalActionDateDecimalYear: 2012.4774590164,
    filingDate: 1439548199999,
    finalActionDate: 1340474400000,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
  {
    date: '2024-08-01',
    filingDateDecimalYear: 2015.621803653,
    finalActionDateDecimalYear: 2012.4816256831,
    filingDate: 1439679600001,
    finalActionDate: 1340606160001,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
  {
    date: '2024-09-01',
    filingDateDecimalYear: 2015.6259703196,
    finalActionDateDecimalYear: 2012.4857923497,
    filingDate: 1439810999998,
    finalActionDate: 1340737919999,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
  {
    date: '2024-10-01',
    filingDateDecimalYear: 2015.6301369863,
    finalActionDateDecimalYear: 2012.4899590164,
    filingDate: 1439942399999,
    finalActionDate: 1340869680000,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
  {
    date: '2024-11-01',
    filingDateDecimalYear: 2015.634303653,
    finalActionDateDecimalYear: 2012.4941256831,
    filingDate: 1440073800001,
    finalActionDate: 1341001440001,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
  {
    date: '2024-12-01',
    filingDateDecimalYear: 2015.6384703196,
    finalActionDateDecimalYear: 2012.4982923497,
    filingDate: 1440205199998,
    finalActionDate: 1341133199999,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
  {
    date: '2025-01-01',
    filingDateDecimalYear: 2015.6426369863,
    finalActionDateDecimalYear: 2012.5024590164,
    filingDate: 1440336599999,
    finalActionDate: 1341264960000,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
  {
    date: '2025-02-01',
    filingDateDecimalYear: 2015.646803653,
    finalActionDateDecimalYear: 2012.5066256831,
    filingDate: 1440468000001,
    finalActionDate: 1341396720001,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
  {
    date: '2025-03-01',
    filingDateDecimalYear: 2015.6509703196,
    finalActionDateDecimalYear: 2012.5107923497,
    filingDate: 1440599399998,
    finalActionDate: 1341528479999,
    filingDateType: 'Date',
    finalActionDateType: 'Date',
  },
]

export const mockVisaBulletinTrendData: ResGetCaseVisaBulletinTrendQuery = [
  {
    bulletinDate: '2025-04-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-07-15',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: -129,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2025-03-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-08',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2025-02-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-08',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2025-01-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-08',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: -7,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2024-12-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-01',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2024-11-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-01',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2024-10-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-01',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2024-09-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-01',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2024-08-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-01',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2024-07-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-01',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2024-06-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-01',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2024-05-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-01',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2024-04-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-01',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2024-03-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-01',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2024-02-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-01',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2024-01-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-01',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2023-12-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-01',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2023-11-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-01',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2023-10-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-01',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2023-09-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-01',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2023-08-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-01',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2023-07-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-01',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2023-06-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-01',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2023-05-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-01',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2023-04-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-01',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2023-03-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-01',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2023-02-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-01',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2023-01-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-01',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2022-12-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-01',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2022-11-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-01',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2022-10-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-01',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2022-09-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-01',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2022-08-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-01',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2022-07-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-01',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2022-06-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-01',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2022-05-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-01',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2022-04-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-01',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2022-03-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-01',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
  {
    bulletinDate: '2022-02-01',
    filingDate: '2015-04-22',
    filingDateType: 'Date',
    finalActionDate: '2012-03-01',
    finalActionDateType: 'Date',
    lastMonthActionDateDiff: 0,
    lastMonthFilingDateDiff: 0,
  },
]
